import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import tradeRequestApi from '../../sources/api/tradeRequestApi';

// constants
import { SEND_MESSAGE } from '../../constants/tradeOffersTypes';

// lib
import httpSaga from '../../lib/httpSaga';
import { toastr } from 'react-redux-toastr';
import { SEND_MESSAGE_ERROR, SEND_MESSAGE_SUCCESS, SEND_MESSAGE_NOT_AUTH } from '../../constants/messages';
import { tooltipHide } from '../../actions/tooltipActions';

export function* sendMessage(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(SEND_MESSAGE, call(tradeRequestApi.sendMessage, params));
    yield put(tooltipHide({ id: params.id }));
    yield toastr.success('Success', SEND_MESSAGE_SUCCESS);
  } catch (e) {
    if (e.response) {
      if (e.response.status === 403) {
        yield toastr.error(SEND_MESSAGE_NOT_AUTH);
      } else {
        yield toastr.error(e.response.body.message);
      }
    } else {
      yield toastr.error(SEND_MESSAGE_ERROR);
    }
    yield put(error(SEND_MESSAGE, e));
  } finally {
    yield put(doneIndicator(SEND_MESSAGE));
  }
}

export function* watchSendMessage() {
  yield takeEvery(SEND_MESSAGE, sendMessage);
}

export default function* root() {
  yield all([
    fork(watchSendMessage)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/tradeOffers/sendMessage.js